import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from '../selectors/projectsSelectors';
import { getEnabledIntegrationPartnersByBusinessId } from '../services/getEnabledIntegrationPartnersByBusinessId';

export const loadBusinessIntegrationPartners = createAsyncThunk(
  'projects/loadBusinessIntegrationPartners',
  async (_, { getState }) => {
    const selectedProject = selectSelectedProject(getState());

    const businessId = selectedProject.business_id;

    if (selectedProject.business_id) {
      const integrationPartners =
        await getEnabledIntegrationPartnersByBusinessId(
          selectedProject.business_id
        );

      return { businessId, integrationPartners };
    }
  }
);
